import { setListener, withEl } from "@front/utils";
import { createComponent } from "@front/utils/alpine";
import prestashop from "prestashop";

type TPersonnalisation = {
    combinations: unknown[];
    idProduct: number;
    url: string;
    features: {
        [key: string]: string[];
    };
};

declare var personnalisationCollection: TPersonnalisation[];

export default createComponent(() => ({
    isOpen: true,
    hasContent: false,
    sizeInput: document.querySelector<HTMLSelectElement>('.js-product-variants select#group_41'),
    isBuyable: true,
    details: '',

    buildDetails () {
        this.details = Array.from(this.$root.querySelectorAll<HTMLOptionElement>('select > option'))
            .filter(o => o.selected)
            .reduce((prev: string[], el) => [...prev, el.text], [])
            .join(' / ')
        ;
    },

    setDummyListeners () {
        setListener<HTMLSelectElement>('.js-personnalisation-dummy', 'input', (_, el) => {
            const variantInput = document.querySelector<HTMLSelectElement>(`.js-product-variants [data-product-attribute="${el.dataset.productAttribute}"]`);

            if (!variantInput) {
                return;
            }

            variantInput.value = el.value;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }, { root: this.$el });
    },

    updateDummies () {
        withEl<HTMLInputElement>('.js-product-variant', (el) => {
            const copyInput = this.$el.querySelector(`.js-personnalisation-dummy[data-product-attribute="${el.dataset.productAttribute}"]`);

            if (copyInput) {
                const parentElement = copyInput.parentElement as HTMLElement;
                copyInput.innerHTML = el.innerHTML;
                parentElement.classList.toggle('hidden', el.value == '');

                if (el.value == '') {
                    parentElement.outerHTML = parentElement.outerHTML.replace(/<div/g, '<section').replace(/<\/div>/g, '</section>')
                } else {
                    parentElement.outerHTML = parentElement.outerHTML.replace(/<section/g, '<div').replace(/<\/section>/g, '</div>')
                }
            }
        });

        this.setDummyListeners();
    },

    checkSize () {
        this.isBuyable = Boolean(this.sizeInput?.value && true);
    },

    init () {

        const customFields = document.querySelectorAll('.js-personnalisation-dummy, .js-personnalisation');
        if(customFields.length) {
            this.hasContent = true;
        }

        $.ajaxPrefilter(function (options, originalOptions) {
            if (!originalOptions.url || originalOptions.url.indexOf('id_product_attribute') == -1) {
                return;
            }

            const url = new URL(originalOptions.url);
            const search_params = new URLSearchParams(url.search);
            var c = search_params.get("group[41]");

            if (c !== null && c=="") {
                var newVal = $('select#group_41 option[value!=""]').attr('value');
                search_params.set("group[41]", newVal ?? '');
                url.search = search_params.toString();
                options.url = url.href;
            }
        });

        this.$watch('isBuyable', () => {
            if(this.sizeInput) {
                const addToCart = document.querySelector('[data-button-action="add-to-cart"]');
                this.isBuyable ? addToCart?.removeAttribute('disabled') : addToCart?.setAttribute('disabled', 'disabled');
            }
        });

        setListener('.js-personnalisation', 'input', () => {
            const redirectTo = personnalisationCollection.find((personnalisation) =>
                Object.entries(personnalisation.features).map(([key, value]) => {
                    const input = document.querySelector<HTMLSelectElement>(`#personnalisation_${key.replace(/\D/g, '')}`);
                    return value.indexOf(input?.value ?? '') > -1;
                }).indexOf(false) === -1
            )?.url;

            if (!redirectTo) {
                alert($('.js-personnalisation-form').data('error'));
                return;
            }

            window.location.href = redirectTo + window.location.hash;
        }, { root: this.$el });

        setListener('.js-personnalisation', 'focus', (event, current) => {
            const currentOptionEls = Array.from(current.querySelectorAll('option')).filter(o => !o.selected);
            const otherPersonnalisationEls = Array.from(this.$el.querySelectorAll<HTMLSelectElement>('.js-personnalisation')).filter(el => el != current);

            currentOptionEls.forEach((opt) => {
                for (const personnalisation of personnalisationCollection) {
                    var isEligible = true;

                    otherPersonnalisationEls.forEach(el => {
                        if (personnalisation.features[`f_${el.dataset.id_feature}`].indexOf(el.value) == -1) {
                            isEligible = false;
                        }
                    });

                    if (isEligible && personnalisation.features[`f_${current.dataset.id_feature}`].indexOf(opt.getAttribute('value') as string) == -1) {
                        isEligible = false;
                    }

                    if (isEligible) {
                        opt.removeAttribute("disabled");
                        break;
                    }

                    opt.setAttribute("disabled", "disabled");
                }
            });
        });

        prestashop.on('updatedProduct', () => {
            this.checkSize();
            this.updateDummies();
            this.buildDetails();
        });

        this.updateDummies();
        this.buildDetails();

        if (this.sizeInput) {
            this.checkSize();
            setListener(this.sizeInput, 'change', () => this.checkSize());
        }
    },

}));
